export class MasterData {
    GrowerId: string;
    Name: string;
    Name2: string;
    Address: string;
    Address2: string;
    PostCode: string;
    City: string;
    Contact: string;
    DeliveryAddress: string;
    CompanyName: string;
    VatNo: string;
    CprNo: string;
    Constituency: string;
    Delegate: string;
    OrganicAuthNo: string;
    Email: string;
    PhoneNo: string;
    PhoneNoText: string;
    CellPhoneNo: string;
    CellPhoneNoText: string; 
    PhoneNo2: string;
    PhoneNo2Text: string;
    PhoneNo3:string;
    PhoneNo3Text: string;
    PhoneNo4: string; 
    PhoneNo4Text: string; 
    CellPhoneNo2: string;
    CellPhoneNo2Text:string;
}
